import api_fetch from "../utils/api_fetch";
import { storageHandler } from '../utils/storage_handler';

const buxferTransactions = {
  // Fetch customer profile by record_id
  getCustomerProfile: async function(record_id, params = {}) {
    try {
      const response = await api_fetch.get(
        `/v1/customer-profile/`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        params,
        record_id
      );
      return await response.json();
    } catch (error) {
      console.error('Error fetching customer profile:', error);
      throw error;
    }
  },

  getCustomerProfileByCode: async function(customerCode, userName = null) {
    try {
      const params = {};
      if (userName) params.userName = userName;
      const response = await api_fetch.get(
        `/v1/customer-profile/`,
        {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        },
        params,
        customerCode
      );
      return await response.json();
    } catch (error) {
      console.error('Error fetching customer profile by code:', error);
      throw error;
    }
  },
    getTransactionById: async function(id) {
        try {
            const response = await api_fetch.get(`/v1/buxfer-transaction/${id}`, {
                Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
            });
            return await response.json();
        } catch (error) {
            console.error('Error fetching transaction by ID:', error);
            throw error;
        }
    },

    getTransactions: async function(
            page = 1, 
            pageSize = 10, 
            keyword = '', 
            email = null, 
            accountName = null,
            status = null, 
            types = null, 
            tags = null, 
            dateFilter = null,
            amount = null,
            customerName = null,
            bankName = null,
            orderBy = "date",
            orderDirection = "desc",
            startDate = null,
            endDate = null
        ) {
            try {
                // Prepare the payload
                const params = {
                    page,
                    pageSize,
                    keyword,
                    email,
                    accountName,
                    status,
                    types,
                    tags,
                    dateFilter,
                    amount,
                    customerName, 
                    bankName,
                    orderBy,
                    orderDirection,
                    startDate,
                    endDate
                };
        
                // Clean up null values
                Object.keys(params).forEach(key => (params[key] === null || params[key] === '') && delete params[key]);
        
                // Sending the request
                const response = await api_fetch.get(
                    '/v1/buxfer-transactions',
                    {
                        Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
                    },
                    params,  
                    ""
                );
                return await response.json();
            } catch (error) {
                console.error('Error fetching transactions:', error);
                throw error;
            }
    },

    getAccountsPaginated: async function (params = {}) {
        try {
          // Clean up null/empty params
          Object.keys(params).forEach(key => (params[key] === null || params[key] === '') && delete params[key]);

          const response = await api_fetch.get(
            '/v1/buxfer-accounts-paginated', // Make sure match sa backend route
            {
              Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
            },
            params,
            ""
          );
          return await response.json();
        } catch (error) {
          console.error('Error fetching paginated accounts:', error);
          throw error;
        }
      },
    exportTransactions: async function(
      keyword,
      accountEmail,
      statusArr,
      typesArr,
      tagsArr,
      dateFilter,
      amount,
      orderBy,
      orderDirection,
      format = "csv"
    ) {
      const query = {
        keyword,
        email: accountEmail,
        dateFilter,
        amount,
        orderBy,
        orderDirection,
        format,
        status: statusArr.join(','),
        types: typesArr.join(','),
        tags: tagsArr.join(','),
      };

      const res = await api_fetch.get(
        '/v1/buxfer-transactions/export',
        { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
        query,
        ''
      );

      if (!res.ok) throw new Error("Export failed");

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `buxfer-transactions.${format}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },

    getUniqueUsers: async function(
        keyword = '',
        email = '',
        status = [],
        types = [],
        tags = [],
        dateFilter = '',
        amount = ''
      ) {
        try {
          const params = {
            search: keyword,
            email,
            status: status.join(','),
            types: types.join(','),
            tags: tags.join(','),
            dateFilter,
            amount
          };
          const response = await api_fetch.get(
            `/v1/buxfer-accounts`,
            { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
            params,
            ""
          );
          return await response.json();
        } catch (error) {
          console.error('Error fetching unique users:', error);
          throw error;
        }
    },
    
    getUniqueTags: async function(
        keyword = '',
        email = '',
        status = [],
        types = [],
        tags = [],
        dateFilter = '',
        amount = ''
      ) {
        try {
          const params = {
            search: keyword,
            email,
            status: status.join(','),
            types: types.join(','),
            tags: tags.join(','),
            dateFilter,
            amount
          };
          const response = await api_fetch.get(
            `/v1/buxfer-transactions/unique-tags`,
            { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
            params,
            ""
          );
          return await response.json();
        } catch (error) {
          console.error('Error fetching unique tags:', error);
          throw error;
        }
    },
    
    getUniqueTypes: async function(
        keyword = '',
        email = '',
        status = [],
        types = [],
        tags = [],
        dateFilter = '',
        amount = ''
      ) {
        try {
          const params = {
            search: keyword,
            email,
            status: status.join(','),
            types: types.join(','),
            tags: tags.join(','),
            dateFilter,
            amount
          };
          const response = await api_fetch.get(
            `/v1/buxfer-transactions/unique-types`,
            { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
            params,
            ""
          );
          return await response.json();
        } catch (error) {
          console.error('Error fetching unique types:', error);
          throw error;
        }
    },
    
    getUniqueStatuses: async function(
        keyword = '',
        email = '',
        status = [],
        types = [],
        tags = [],
        dateFilter = '',
        amount = ''
      ) {
        try {
          const params = {
            search: keyword,
            email,
            status: status.join(','),
            types: types.join(','),
            tags: tags.join(','),
            dateFilter,
            amount
          };
          const response = await api_fetch.get(
            `/v1/buxfer-transactions/unique-statuses`,
            { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
            params,
            ""
          );
          return await response.json();
        } catch (error) {
          console.error('Error fetching unique statuses:', error);
          throw error;
        }
    },

    // Activity Statement Autopay
    getActivityStatementAutopay: async function({ user_id = '', user_ids = [], page = 1, pageSize = 25, keyword = '' } = {}) {
      try {
        const params = { page, pageSize, keyword };
        if (user_id) params.user_id = user_id;
        if (user_ids && Array.isArray(user_ids) && user_ids.length) params.user_ids = user_ids.join(',');
        Object.keys(params).forEach(key => (params[key] === null || params[key] === '') && delete params[key]);
        const response = await api_fetch.get(
          '/v1/activity-statement-autopay',
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          params,
          ''
        );
        return await response.json();
      } catch (error) {
        console.error('Error fetching activity statement autopay:', error);
        throw error;
      }
    },

    searchTransactions: async function (keyword = '') {
        try {
            const params = { keyword };
            const response = await api_fetch.get(
                `/v1/buxfer-transactions/suggestions`,
                { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
                params,
                ""
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching transaction suggestions:', error);
            throw error;
        }
    },
    
    getUniqueUsernames: async function (keyword = '', page = 1, limit = 10, orderBy = null, orderDirection = 'DESC') {
        try {
            const params = {
                keyword,
                page,
                limit,
                orderBy,
                orderDirection
            };
            const response = await api_fetch.get(
                `/v1/buxfer-transactions/unique-usernames`,
                { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
                params,
                ""
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching username:', error);
            throw error;
        }
    },

  getAccountsFromEnvUsers: async function (keyword = '', page = 1, limit = 100, orderBy = null, orderDirection = 'DESC') {
    try {
      const params = {
        keyword,
        page,
        limit,
        orderBy,
        orderDirection
      };
      Object.keys(params).forEach(key => (params[key] === null || params[key] === '') && delete params[key]);

      const response = await api_fetch.get(
        `/v1/buxfer-accounts-from-env`,
        { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
        params,
        ""
      );
      return await response.json();
    } catch (error) {
      console.error('Error fetching accounts from env users:', error);
      throw error;
    }
  },
  getSpendingReport: async function({ groupBy = 'customer', year = null, page = 1, pageSize = 50, keyword = '' } = {}) {
    try {
      const params = { groupBy, page, pageSize };
      if (year) params.year = year;
      if (keyword) params.keyword = keyword;
      const response = await api_fetch.get(
        '/v1/spending-report',
        { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
        params,
        ''
      );
      return await response.json();
    } catch (error) {
      console.error('Error fetching spending report:', error);
      throw error;
    }
  },
    
    getUniqueLoginId: async function (keyword = '') {
        try {
            const params = { keyword };
            const response = await api_fetch.get(
                `/v1/buxfer-transactions/unique-login-id`,
                { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
                params,
                ""
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching username:', error);
            throw error;
        }
    },

    getDistinctCustomers: async function() {
      try {
        const response = await api_fetch.get(
          `/v1/buxfer-distinct-customers`,
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          {},
          ""
        );
        return await response.json();
      } catch (error) {
        console.error('Error fetching distinct customers:', error);
        throw error;
      }
    },
    updateAccountStatus: async function(id, status) {
      try {
        const body = { status };
        // api_fetch.patch(url, headers_json, query_json, params, body)
        const res = await api_fetch.patch(
          `/v1/buxfer-account/${id}/status`,
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          {},
          '',
          body
        );
        return await res.json();
      } catch (error) {
        console.error('Error updating account status:', error);
        throw error;
      }
    },
    // Notes CRUD
    listNotes: async function(accountId) {
      try {
        const res = await api_fetch.get(
          `/v1/buxfer-account/${accountId}/notes`,
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          {},
          ''
        );
        return await res.json();
      } catch (error) {
        console.error('Error listing notes:', error);
        throw error;
      }
    },
    createNote: async function(accountId, author, text) {
      try {
        const res = await api_fetch.post(
          `/v1/buxfer-account/${accountId}/notes`,
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          {},
          '',
          { author, text }
        );
        return await res.json();
      } catch (error) {
        console.error('Error creating note:', error);
        throw error;
      }
    },
    updateNote: async function(noteId, text) {
      try {
        const res = await api_fetch.put(
          `/v1/buxfer-account/notes/${noteId}`,
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          {},
          '',
          { text }
        );
        return await res.json();
      } catch (error) {
        console.error('Error updating note:', error);
        throw error;
      }
    },
    deleteNote: async function(noteId) {
      try {
        const res = await api_fetch.delete(
          `/v1/buxfer-account/notes/${noteId}`,
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          {},
          '',
          {}
        );
        return await res.json();
      } catch (error) {
        console.error('Error deleting note:', error);
        throw error;
      }
    },

    getDistinctBanks: async function() {
      try {
        const response = await api_fetch.get(
          `/v1/buxfer-distinct-banks`,
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          {},
          ""
        );
        return await response.json();
      } catch (error) {
        console.error('Error fetching distinct banks:', error);
        throw error;
      }
    },

    getLoginsForCustomerAndBank: async function(customerName = '', bankName = '') {
      try {
        const params = {};
        if (customerName) params.customerName = customerName;
        if (bankName) params.bankName = bankName;
        const response = await api_fetch.get(
          `/v1/buxfer-logins`,
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          params,
          ""
        );
        return await response.json();
      } catch (error) {
        console.error('Error fetching logins for customer and bank:', error);
        throw error;
      }
    },

    getNotSyncedAccountsByUser: async function (
      userName,
      page = 1,
      limit = 10,
      keyword = '',
      isNotSynced = null, // pass true, false, or null
      orderBy = 'lastSynced',
      orderDirection = 'DESC'
    ) {
      try {
        const query = {
          page,
          limit,
          keyword,
          orderBy,
          orderDirection,
        };

        if (isNotSynced !== null) {
          query.filterNotSyncedOnly = isNotSynced;
        }

        const response = await api_fetch.get(
          `/v1/buxfer/not-synced/${userName}`,
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          query,
          ""
        );

        return await response.json();
      } catch (error) {
        console.error('Error fetching not-synced accounts by user:', error);
        throw error;
      }
    },

    exportNotSyncedAccounts: async function (
      userName,
      keyword = '',
      filterNotSyncedOnly = null,
      format = 'csv'
    ) {
      const query = {
        keyword,
        filterNotSyncedOnly,
        format,
      };

      const res = await api_fetch.get(
        `/v1/buxfer/not-synced-export/${userName}`,
        { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
        query,
        ''
      );

      if (!res.ok) throw new Error('Export failed');

      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `not-synced-accounts.${format}`;
      document.body.appendChild(link);
      link.click();
      link.remove();
    },

    getAccountsPaginated: async function({
        page = 1,
        pageSize = 50,
        keyword = '',
        customerName = null,
        bankName = null,
        status = null,
        minBalance = null,
        maxBalance = null,
        minCreditLine = null,
        maxCreditLine = null,
        lastSyncStatus = null,
        orderBy = 'name',
        orderDirection = 'ASC'
    } = {}) {
        try {
            const params = {
                page,
                pageSize,
                keyword,
                customerName,
                bankName,
                status,
                minBalance,
                maxBalance,
                minCreditLine,
                maxCreditLine,
                lastSyncStatus,
                orderBy,
                orderDirection
            };
            Object.keys(params).forEach(key => (params[key] === null || params[key] === '') && delete params[key]);
            const response = await api_fetch.get(
                `/v1/buxfer-accounts-paginated`,
                { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
                params,
                ""
            );
            return await response.json();
        } catch (error) {
            console.error('Error fetching paginated accounts:', error);
            throw error;
        }
    },

    getAccounts: async function (
      userName,
      page = 1,
      limit = 10,
      keyword = '',
      orderBy = null,
      orderDirection = 'DESC',
      uniqueByEmail = false
    ) {
      try {
        const query = {
          userName,
          page,
          limit,
          keyword,
          sortBy: orderBy,          // 🔄 renamed
          sortDirection: orderDirection, // 🔄 renamed
          uniqueByEmail
        };

        Object.keys(query).forEach(key => {
          if (query[key] === null || query[key] === '') {
            delete query[key];
          }
        });

        const response = await api_fetch.get(
          `/v1/buxfer-login-ids`, // ✅ cleaned URL
          {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`,
          },
          query,
          ""
        );

        return await response.json();
      } catch (error) {
        console.error('Error fetching not-synced accounts by user:', error);
        throw error;
      }
    },

    getSyncHistory: async function({ page = 1, pageSize = 50, keyword = '', accountName = '', buxaccount_email = '', status = '', dateFrom = '', dateTo = '', minTxCount = '', maxTxCount = '', orderBy = 'date_synced', orderDirection = 'DESC' } = {}) {
      try {
        const params = { page, pageSize, keyword, accountName, buxaccount_email, status, dateFrom, dateTo, minTxCount, maxTxCount, orderBy, orderDirection };
        Object.keys(params).forEach(key => (params[key] === null || params[key] === '') && delete params[key]);
        const res = await api_fetch.get(
          '/v1/buxfer-sync-history',
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          params,
          ''
        );
        return await res.json();
      } catch (error) {
        console.error('Error fetching sync history:', error);
        throw error;
      }
    },

    getSyncSummary: async function() {
      try {
        const res = await api_fetch.get(
          '/v1/buxfer-sync-summary',
          { Authorization: `Bearer ${storageHandler.localStorageGet('token')}` },
          {},
          ''
        );
        return await res.json();
      } catch (error) {
        console.error('Error fetching sync summary:', error);
        throw error;
      }
    },

    syncAccount: async function (email, deepSync = false, days = 49) {
      try {
        const response = await api_fetch.post(
          `/v1/buxfer-sync`,
          {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
          },
          {},
          "",
          { email, deepSync, days }
        );
        return await response.json();
      } catch (error) {
        console.error('Error syncing account:', error);
        throw error;
      }
    },

    getCardByIdentifier: async function(identifier) {
      try {
        const response = await api_fetch.get(`/v1/corteza-card/`, {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, {}, identifier);
        return await response.json();
      } catch (error) {
        console.error('Error fetching card by identifier:', error);
        throw error;
      }
    },

    getCardAndCustomerByIdentifier: async function(identifier) {
      try {
        const response = await api_fetch.get(`/v1/corteza-customer/`, {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, {}, identifier);
        return await response.json();
      } catch (error) {
        console.error('Error fetching card by identifier:', error);
        throw error;
      }
    },

    getCortezaCustomers: async function(keyword = '', page = 1, limit = 10) {
      try {
        const response = await api_fetch.get(
          `/v1/corteza-customers`,
          {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
          },
          {
            keyword,
            page,
            limit
          },
          '' // params (wala tayong id dito kaya empty string)
        );
        return await response.json();
      } catch (error) {
        console.error('Error fetching corteza customers:', error);
        throw error;
      }
    },

    getCreditCardCustomers: async function(search = '', status = [], page = null, pageSize = null) {
      try {
        const params = {};
        if (search) params.search = search;
        if (status && status.length > 0) params.status = status;
        if (page) params.page = page;
        if (pageSize) params.pageSize = pageSize;
        const response = await api_fetch.get('/v1/credit-card-customers', {
          Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
        }, params, "");
        return await response.json();
      } catch (error) {
        console.error('Error fetching credit card customers:', error);
        throw error;
      }
    },

    getStatusLabels: async function() {
      try {
        const response = await api_fetch.get(
          '/v1/status-labels',
          {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
          }, 
          {},
          ''
        );
        const data = await response.json();
        return data.result || ['Active', 'Exiting'];
      } catch (error) {
        console.error('Error fetching status labels:', error);
        // Return defaults if API fails
        return ['Active', 'Exiting'];
      }
    },

    updateStatusLabels: async function(labels) {
      try {
        const response = await api_fetch.post(
          '/v1/status-labels',
          {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
          },
          {}, // no query params
          '', // no additional URL params
          { labels }
        );
        return await response.json();
      } catch (error) {
        console.error('Error updating status labels:', error);
        throw error;
      }
    },

    updateAccountsFromCSV: async function(csvContent) {
      try {
        const response = await api_fetch.post(
          '/v1/buxfer-accounts/update-csv',
          {
            Authorization: `Bearer ${storageHandler.localStorageGet('token')}`
          },
          {}, // no query params
          '', // no additional URL params
          { csvContent }
        );
        return await response.json();
      } catch (error) {
        console.error('Error updating accounts from CSV:', error);
        throw error;
      }
    },

}

export default buxferTransactions;
